export default __webpack_public_path__ + "static/media/walletconnect.dde2795c.svg";